import React, { useState } from 'react';
import { Brain, ChevronDown, ChevronUp } from 'lucide-react';

const ThinkingProcess = ({ thinkingProcess, reasoning = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!thinkingProcess && (!reasoning || reasoning.length === 0)) {
    return null;
  }

  return (
    <div className="thinking-process bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-3 my-2">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-left"
      >
        <div className="flex items-center space-x-2">
          <Brain className="h-4 w-4 text-purple-600 dark:text-purple-400 animate-pulse" />
          <span className="text-xs font-semibold text-gray-900 dark:text-white">
            Thinking Process
          </span>
          {reasoning.length > 0 && (
            <span className="text-xs text-gray-500 dark:text-gray-400">
              ({reasoning.length} step{reasoning.length !== 1 ? 's' : ''})
            </span>
          )}
        </div>
        {isExpanded ? (
          <ChevronUp className="h-4 w-4 text-gray-500" />
        ) : (
          <ChevronDown className="h-4 w-4 text-gray-500" />
        )}
      </button>

      {isExpanded && (
        <div className="mt-3 space-y-3">
          {reasoning.length > 0 ? (
            reasoning.map((step, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-800 rounded p-2 border border-purple-100 dark:border-purple-900"
              >
                <div className="flex items-center space-x-2 mb-1">
                  <span className="text-xs font-medium text-purple-600 dark:text-purple-400">
                    Step {step.step}:
                  </span>
                  {step.timestamp && (
                    <span className="text-xs text-gray-400">
                      {new Date(step.timestamp).toLocaleTimeString()}
                    </span>
                  )}
                </div>
                <p className="text-xs text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                  {step.reasoning}
                </p>
              </div>
            ))
          ) : (
            <div className="bg-white dark:bg-gray-800 rounded p-2 border border-purple-100 dark:border-purple-900">
              <p className="text-xs text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                {thinkingProcess}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ThinkingProcess;

